<template>
	<div class="choice-route-content">
		<el-dialog
			v-if="dialogVisible"
			:title="agent.agentName"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="680px"
		>
			<p class="margin10">
				<span class="color999">地址：</span>
				<span class="color606266">{{ agentInfo.posAddress }}</span>
				<span class="color999 ml20">渠道：</span>
				<span class="color606266">{{ agentInfo.channelName }}</span>
			</p>
			<div class="flex margin10">
				<p class="flex-1">
					<span>SAP编号：</span>
					<span>{{ agentInfo.sapAgentNo }}</span>
				</p>
				<p class="flex-1">
					<span>销售据点分类：</span>
					<span>{{ agentInfo.agentTag1 }}</span>
				</p>
				<!-- <p class="flex-1">
					<span>销售模式：</span>
					<span>{{ agentInfo.agentTag2 }}</span>
				</p> -->
			</div>
            <p class="title">路线及配送周期</p>
            <div class="pl10 pr10">
                <el-table
                    border
                    :data="routelist"
                    :header-cell-style="{
                        background: 'rgba(200, 204, 215,.6)',
                        color: '#333333'
                    }"
                >
                    <el-table-column prop="routeName" label="路线" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column v-for="(item,i) in weeklist" :key="i" width="60" :label="item.name" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{ scope.row[item.parameter] > 0 ? '✓' : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80">
                        <template slot-scope="scope">
							<button type="button" class="view-btn" @click="handleDeleteAgent(scope.row.routeId)">移除</button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <p class="title">上月销售及最近库存（瓶）</p>
            <div class="pl10 pr10">
                <el-table
                    border
                    :data="agentInfo.lmsums"
                    :header-cell-style="{
                        background: 'rgba(200, 204, 215,.6)',
                        color: '#333333'
                    }"
                >
					<el-table-column align="center" type="index" width="80px">
						<template slot-scope="scope">
							{{ lmsumsName[scope.$index] }}
						</template>
					</el-table-column>
                    <el-table-column v-for="(item,i) in titles1" :key="i" :label="item.key" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{ scope.row[item.value] }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <p class="title">生动化检查</p>
            <div class="pl10 pr10">
				<el-table
                    border
                    :data="agentInfo.storeChecks"
                    :header-cell-style="{
                        background: 'rgba(200, 204, 215,.6)',
                        color: '#333333'
                    }"
                >
					<el-table-column align="center" type="index" width="80px">
						<template slot-scope="scope">
							{{ storeChecksName[scope.$index] }}
						</template>
					</el-table-column>
                    <el-table-column v-for="(item,i) in titles2" :key="i" :label="item.key" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            {{ scope.row[item.value] }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
			<div class="margin10 flex">
				<span class="flags" v-for="(v,k,i) in agentInfo.flags">
					<img v-if="v == 'Y'" src="@/assets/images/radio.png" alt="">
					<span v-else></span>
					{{ k }}
				</span>
			</div>
			<p class="title">棚椴排面照片</p>
			<ul class="ul-img">
				<li v-for="(item,i) in photos" :key="i+'li'" @click="viewerHandle(i)">
					<img :key="i+'img'" :src="item.photoUrl" alt="">
				</li>
			</ul>
		</el-dialog>
		<!-- 照片预览 -->
		<viewer ref="viewer" v-if="viewFlag" @closeViewer="closeViewer"></viewer>
	</div>
</template>
<script>
import viewer from '@/components/viewer'
export default {
	components: {
		viewer
	},
	data() {
		return {
			dialogVisible: false,
			agent: null,
			agentInfo: {
                posAddress: '',
                routeName: '',
                sapAgentNo: '',
                channelName: '',
                agentTag1: '',
                agentTag2: '',
                lmsums: [],
                storeChecks: [],
            },
			// 上月销售及库存
            lmsumsName: [
                '总计销售',
                '日均销售',
                '最近库存'
            ],
			// 生动化检查
            storeChecksName: [
                '棚椴',
                '排面'
            ],
			// 当前组织id
			groupId: '',
			// 序号
			deliverSort: '',
			// 棚椴排面照片列表
			photos: [],
			// 路线列表
			routelist: [],
			weeklist: [
				{
					name: '周一',
					parameter: 'monSort'
				},
				{
					name: '周二',
					parameter: 'tuesSort'
				},
				{
					name: '周三',
					parameter: 'wedSort'
				},
				{
					name: '周四',
					parameter: 'thurSort'
				},
				{
					name: '周五',
					parameter: 'friSort'
				},
				{
					name: '周六',
					parameter: 'satSort'
				},
				{
					name: '周日',
					parameter: 'sunSort'
				}
			],
			// 上月销售及最近库存（瓶）title
            titles1: [],
			// 生动化检查
            titles2: [],
			// 图片预览弹窗控件
			viewFlag: false
		};
	},
	methods: {
		init(agent, groupId) {
			this.$nextTick(() => {
				this.dialogVisible = true;
				this.agent = agent;
				this.groupId = groupId;
				this.deliverSort = '';
				// 获取店铺详细数据
				this.$request
					.post("routeMapAgentInfo", true, {
						routeId: agent.routeId,
						agentId: agent.agentId,
						groupId: groupId,
						agentType: agent.agentType == "route" ? "0" : "1"
					})
					.then(res => {
						this.agentInfo = res.data;
						this.photos = res.data.photos == null ? [] : res.data.photos;
						this.routelist = res.data.routelist == null ? [] : res.data.routelist;
                        this.titles1 = res.data.titles1;
                        this.titles2 = res.data.titles2;
					})
			});
		},
		// 删除单个店铺
		handleDeleteAgent(routeId) {
			this.$confirm("确认要从现路线中移除吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					// 路线
					if(this.agent.agentType == "route") {
						this.$request
							.post("routeDelAgent",false, {
									recordIds: [this.agent.recordId],
									routeId: this.agent.routeId
							})
							.then((res) => {
								if(res.code == "0") {
									this.$message.success('删除成功');
								}
								this.dialogVisible = false;
								this.$emit('getRouteInfo');
							})
					}
					// 路线地图
					else {
						this.$request
							.post("routeMapDeleteAgent", true, {
								changeAgents: [{
									routeId: routeId,
									agentId: this.agent.agentId
								}]
							})
							.then(res => {
								if(res.code == "0") {
									this.$message.success('删除成功');
								}
								this.dialogVisible = false;
								this.$emit('getRouteInfo');
							});
					}
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除"
					});
				});
		},
		// 获取路线数组
		getRouteList() {
			this.$request
				.post("listRAgents", true, {
					agentId: this.agent.agentId
				})
				.then(res => {
					this.routelist = res.data == null ? [] : res.data;
				})
		},
		// 图片预览
		viewerHandle(index) {
			this.viewFlag = true;
			this.$nextTick(() => {
				let imageList = [];
				for (const iterator of this.photos) {
					imageList.push(iterator.photoUrl);
				}
				this.$refs.viewer.init(index, imageList);
			})
		},
		// 关闭图片预览弹窗
		closeViewer() {
			this.viewFlag = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.icon-s {
	width: 32px;
	height: 32px;
	cursor: pointer;
}

.footer {
	margin-top: 20px;
	display: flex;
	li {
		flex: 1;
		list-style: none;
		text-align: center;
	}
}

.choice-route-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}

.choice-route-content /deep/ .el-table .cell,
.choice-route-content /deep/ .el-table .el-table__cell,
.choice-route-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 1px 5px !important;
}

.choice-route-content /deep/ .el-table .cell,
.choice-route-content /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding-left: 0;
}

.margin10{
	margin: 10px;
}

.title{
    background-color: #e5e5e5;
    color: #333;
    font-size: 14px;
    padding: 10px 5px;
    margin: 4px 10px 2px;
	font-weight: bold;
}

.pl10{
    padding-left: 10px;
}

.pr10{
    padding-right: 10px;
}

.flags{
	display: flex;
	margin-right: 20px;
	font-weight: bold;
	img{
		width: 19px;
		height: 19px;
		margin-right: 4px;
	}
	span{
		display: inline-block;
		width: 15px;
		height: 15px;
		border: 2px solid #1296db;
		border-radius: 15px;
		margin-right: 4px;
	}
}

.width60{
	width: 60px;
}

.ml40{
	margin-left: 40px;
}

.flex-1 {
	span:nth-child(1) {
		color: #999;
	}
	span:nth-child(2) {
		color: #606266;
	}
}

.color999{
	color: #999;
}

.color606266 {
	color: #606266;
}

.ul-img{
	margin: 4px 10px 2px;
	li {
		list-style: none;
		display: inline-block;
		img{
			margin-right: 10px;
			width: 110px;
			height: 110px;
		}
	}
}

.ml20{
	margin-left: 10px;
}

.choice-route-content /deep/ .el-button:focus,
.choice-route-content /deep/ .el-button:hover {
	color: unset;
    border-color: #DCDFE6;
    background-color: #fff;
}

.view-btn {
	border: none;
	outline: none;
	color: #1bc9b5;
	background-color: rgba(27, 201, 181, 0.1);
	padding: 5px 10px;
	border-radius: 5px;
	cursor: pointer;
}
</style>
